import React, { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';

// Import your image assets
import cu1 from '../../assets/cu1.png';
import cu2 from '../../assets/cu2.png';
import cu3 from '../../assets/cu3.png';

export default function CarouselComponent() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const autoAdvanceCarousel = () => {
    const newIndex = (index + 1) % 3; // Assuming you have 3 images
    setIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(autoAdvanceCarousel, 5000); // Advance every 5 seconds
    return () => clearInterval(interval);
  }, [index]);

  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
      <Carousel.Item>
        <img className="d-block w-100" src={cu1} alt="First slide" />
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src={cu2} alt="Second slide" />
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src={cu3} alt="Third slide" />
      </Carousel.Item>
    </Carousel>
  );
}
